import React, { FunctionComponent, memo } from 'react';
import { FunctionColor, cn } from '@lux/core';
import { Translate } from '@pegasus/translation';
import { Text, Preset } from '@lux/text/tw';

import { Campaign } from '@shared/types/mylounge';

import { useConfig } from '@browsing/config';

interface Props {
    campaign: Campaign;
    isPlusVariant?: boolean;
    cardVariant?: 'mini' | 'compact';
}

export const Discount: FunctionComponent<Props> = ({
    campaign,
    isPlusVariant = false,
    cardVariant,
}) => {
    const config = useConfig();
    const isRRPComplainceEnabled = config.isEnabled('omnibusRRP');
    const isCardMini = cardVariant === 'mini';
    const isCardCompact = cardVariant === 'compact';

    if (campaign.discount.isSpecial) {
        return (
            <Text
                className={cn(
                    'pl-xs m-0 flex justify-center self-end',
                    (isCardCompact || isCardMini) && 'pl-0',
                )}
                preset={isCardMini ? Preset.S : Preset.M}
                color={isPlusVariant ? FunctionColor.function0 : FunctionColor.function100}
                bold
            >
                <Translate message="campaigns.campaignSpecial" />
            </Text>
        );
    }

    if (isRRPComplainceEnabled) {
        return (
            <Text
                className={cn(
                    'pl-xs text-right',
                    '[&_.br]:block',
                    '[&_.discount]:font-bold',
                    isPlusVariant
                        ? '[&_.discount]:text-function-0'
                        : '[&_.discount]:text-function-100',
                    (isCardMini || isCardCompact) && 'pl-0',
                )}
                preset={isCardMini || isCardCompact ? Preset.S : Preset.XS}
                color={isPlusVariant ? FunctionColor.function0 : FunctionColor.function60}
            >
                <Translate
                    message="campaigns.omniBusComplaince"
                    params={{ discount: `${campaign.discount.maxDiscount}` }}
                    html
                />
            </Text>
        );
    }

    return (
        <div
            className={cn(
                'm-0 flex h-auto flex-col justify-between text-right lowercase ',
                (isCardMini || isCardCompact) && 'block text-left',
            )}
        >
            <Text
                className={cn('pl-xs', (isCardMini || isCardCompact) && 'pl-0')}
                preset={isCardCompact || isCardMini ? Preset.S : Preset.XS}
                color={isPlusVariant ? FunctionColor.function0 : FunctionColor.function60}
            >
                <Translate message="campaigns.upTo" />
            </Text>
            <Text
                className={cn('text-right', "before:content-['_']")}
                preset={isCardCompact || isCardMini ? Preset.S : Preset.M}
                bold
                color={isPlusVariant ? FunctionColor.function0 : FunctionColor.function100}
            >
                {campaign.discount.maxDiscount}%
            </Text>
        </div>
    );
};

export default memo(Discount);
